module.exports = __webpack_public_path__ + "static/media/gallery-blank.659934da.svg";